import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { intlDate } from "@faire/web--source/common/localization/date-fns/intlDate";
import isSameMonth from "date-fns/isSameMonth";
var _obj;
var dateFormatForAllowedMonthFormats = (_obj = {}, _define_property(_obj, "MMM", "MMM d"), _define_property(_obj, "MMMM", "MMMM d"), _obj);
export var localDateRange = function(startDate, endDate, formatters) {
    var _formatters_monthFormat;
    var monthFormat = (_formatters_monthFormat = formatters.monthFormat) !== null && _formatters_monthFormat !== void 0 ? _formatters_monthFormat : "MMMM";
    var shouldDisplaySameMonth = isSameMonth(startDate, endDate);
    if (shouldDisplaySameMonth) {
        var startMonthDate = intlDate(startDate, monthFormat);
        var startDayNumber = intlDate(startDate, "d");
        var endDayNumber = intlDate(endDate, "d");
        return formatters.sameMonthFormatter({
            startMonthDate: startMonthDate,
            startDayNumber: startDayNumber,
            endDayNumber: endDayNumber
        });
    }
    var dateFormat = dateFormatForAllowedMonthFormats[monthFormat];
    var formattedStartDate = intlDate(startDate, dateFormat);
    var formattedEndDate = intlDate(endDate, dateFormat);
    return formatters.differentMonthFormatter({
        startDate: formattedStartDate,
        endDate: formattedEndDate
    });
};
